import { inject } from 'vue';
import Mustache from 'mustache';

export default function useRenderLiquid({ liquidRenderingEnabled = false, modelValue = {} } = {}) {
  const $bct = inject('translator');

  function renderText(text) {
    if (!text) return '';

    // assumes that translation will avoid disrupting {{}} syntax
    const sanitizedText = replaceLiquidSyntax(text);
    const translatedValue = $bct(sanitizedText);

    return isLiquidValue(translatedValue) ? renderLiquidValue(translatedValue) : translatedValue;
  }

  function isLiquidValue(value) {
    if (!value) return false;

    return value.includes('-%');
  }

  function renderLiquidValue(value) {
    if (!liquidRenderingEnabled) return value;

    return Mustache.render(value, modelValue, {}, ['-%', '%-']).replace('&#39;', "'");
  }

  function replaceLiquidSyntax(text) {
    if (!liquidRenderingEnabled) return text;

    return text.replace(/{{/g, '-%').replace(/}}/g, '%-');
  }

  return {
    renderText,
  };
}
